import React from "react";

import { BaseTooltip, type BaseTooltipProps } from "./BaseTooltip";

const OVERLAY_STYLE: React.CSSProperties = {
	zIndex: 3000,
	maxWidth: 275,
};

export interface TooltipProps extends BaseTooltipProps {
	/**
	 * @default true
	 */
	visible?: boolean;

	/**
	 * Delay in milliseconds before the tooltip appears.
	 * @default 700
	 */
	mouseEnterDelay?: number;
}

export const Tooltip: React.FC<React.PropsWithChildren<TooltipProps>> = ({
	visible = true,
	mouseEnterDelay = 700,
	overlayStyle,
	...props
}) => (
	<BaseTooltip
		mouseEnterDelay={mouseEnterDelay / 1000}
		overlayStyle={{
			...OVERLAY_STYLE,
			...overlayStyle,
			visibility: visible ? "visible" : "hidden",
		}}
		{...props}
	/>
);
